import React, { Component } from 'react';
import './Alert.css';

class AlertV2 extends Component {
  render() {
    return (
      <div className={`alert ${this.props.className}`}>
        <span>{this.props.text}</span>
      </div>
    );
  }
}

export default AlertV2;
